<template>
	<div class="topicLibrary">
		<navBar>
			{{ title }}
		</navBar>
		<div class="content-box">
			<ul class="data-list">
				<template v-for="(item, index) in videosList">
					<li :key="index" v-if="currentVideo == index || currentVideo == '9527'">
						<div class="video-box" :id="`video${index}`" ></div>
						<div class="title">
							<span>{{ item.name }}</span>
						</div>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
import DPlayer from 'dplayer';
export default {
	name: 'indexPage',
	data() {
		return {
			isWechat: true,
			currentVideo: '9527',
			selected: '10000',
			title:this.$route.query.name,
			videosList: [
				{
					mask: require('@/assets/img/00.png'),
					title: '语文考点精讲',
					url: 'https://aixuebang-1310518323.file.myqcloud.com/videojingdian985/yuwen/kdjj/wenyanwen.mp4',
					img: 'https://aixuebang-1310518323.file.myqcloud.com/videojingdian985/laoshiimage/yuwen.png',
					des: '初中语文文言文特殊句式四大类型--精准学'
				},
				{
					mask: require('@/assets/img/00.png'),
					title: '英语考点精讲',
					url: 'https://aixuebang-1310518323.file.myqcloud.com/videojingdian985/yingyu/kdjj/2020ydlj.mp4',
					img: 'https://aixuebang-1310518323.file.myqcloud.com/videojingdian985/laoshiimage/yingyu.png',
					des: '初中英语阅读理解--精准学'
				},
				{
					mask: require('@/assets/img/00.png'),
					title: '数学考点精讲',
					url: 'https://aixuebang-1310518323.file.myqcloud.com/videojingdian985/shuxue/kdjj/sxkdjj.mp4',
					img: 'https://aixuebang-1310518323.file.myqcloud.com/videojingdian985/laoshiimage/shuxue.png',
					des: '初中数学全等三角形--精准学'
				}
			],
			dplayerObj: []
		};
	},

	created() {},
	mounted() {
		this.getvideolist();
		// this.ShareImpl(option);
	},
	methods: {
		getvideolist(){
			this.$api
				.getvideolist({
					bookid: this.$route.query.bookid,
					chapterid: this.$route.query.id
				})
				.then((res) => {
					let resData = res.data || [];
					this.videosList = resData;
					this.initPage()
				});
		},
		setstudyreport(contentid) {
			console.log(this.$route.query.id,'this.$route.query.idthis.$route.query.id')
			this.$api
				.setstudyreport({
					type: 2,
					contentid: contentid,
					bookid: this.$route.query.bookid,
					chapterid: this.$route.query.id||this.$route.query.chapterid
				})
				.then((res) => {
					console.log(res);
				});
		},
		initPage() {
			for (let i = 0; i < this.videosList.length; i++) {
				if (this.currentVideo == i || this.currentVideo == '9527') {
					let videoDom = window.document.getElementById(`video${i}`);
					let opt = {
						url: this.videosList[i].medium,
						pic: this.videosList[i].image
					};
					let dplayerItem = new DPlayer({
						container: videoDom,
						video: opt,
						theme: '#20a287'
					});
					videoDom.addEventListener("click",()=>{
						this.setstudyreport(this.videosList[i].id)
						this.addscore(this.videosList[i])
					})
					this.$set(this.dplayerObj, i, dplayerItem);
				} else {
					this.$set(this.dplayerObj, i, null);
				}
			}
		},
		addscore(item){
				let bookid = Number(this.$route.query.bookid) ;
				let chapterid = this.$route.query.chapterid;
				let apiData = {
					bookid:bookid,
					chapterid:chapterid,
					score:item.credit,
					type:2,
					contentid:item.id,
				}
				this.$api
					.addscore(apiData)
					.then(() => {
						
					});
		},
	}
};
</script>

<style lang="scss" scoped>
::v-deep .dplayer-menu {
	display: none !important;
}
.topicLibrary {
	height: calc(100% - 1.08rem);
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	background: #f5faff;
	.content-box {
		.data-list {
			padding: 10px;
			list-style: none;
			li {
				margin-bottom: 15px;
				min-height: 195px;
				.video-box {
					width: 100%;
					margin-bottom: 5px;
					font-size: 14px;
					::v-deep .dplayer-menu {
						display: none !important;
					}
					::v-deep .dplayer-full-in-icon {
						display: none !important;
					}
				}
				.title {
					display: flex;
					justify-content: space-between;
					align-items: center;
					width: 100%;
					font-size: 13px;
					color: #333;
					text-align: center;
					.share-btn {
						width: 15px;
						height: 15px;
						border: 1px #27a286 solid;
						border-radius: 50%;
					}
					.active {
						position: relative;
						&::after {
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
							content: '';
							width: 10px;
							height: 10px;
							background: #27a286;
							border-radius: 50%;
						}
					}
				}
			}
		}
	}
}
</style>

